import {ReactNode} from "react";
import {Container, Text} from "@bounce/shared/ui";

type Props = {
  title: string;
  children?: ReactNode;
};

export const ListPageHeader = ({title, children}: Props) => (
  <Container row fullWidth sx={{justifyContent: "space-between", alignItems: "center", mb: 3}}>
    <Text size={24} variant="interDisplay600">
      {title}
    </Text>
    {children && (
      <Container row sx={{gap: 1.5, alignItems: "center"}}>
        {children}
      </Container>
    )}
  </Container>
);
